export default "__VITE_ASSET__403c98c9__"